import { lazy } from "react"

export const HierarchyGraph = lazy(() =>
  import("../HierarchyGraph").catch(() => ({
    default: () => <div>Failed to load Hierarchy Graph</div>
  }))
)

export const AiComponentsTabs = lazy(() =>
  import("./AiComponentsTabs").catch(() => ({
    default: () => <div>Failed to load AI Components Tabs</div>
  }))
)
